

var theWindow ; 
(function ($) {
theWindow = $(window);

theWindow.trigger("window:resize");

setTimeout(() => {
  document.body.classList.remove("preload");

}, 500);

theWindow.on('resize', function () {
  document.body.classList.add("resizing-page");

  setTimeout(() => {
    theWindow.trigger("window:resize");
    document.body.classList.remove("resizing-page");
  }, 150);
});




  ///////////////////////////////////////////////////////////////////////////
  //Randomize                                       
  ///////////////////////////////////////////////////////////////////////////

  $.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function () {
        $(this).children(selector).sort(function (childA, childB) {
            // * Prevent last slide from being reordered
            if($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};


})(jQuery); // or even jQuery.noConflict()